<template>
    <div class="header_box">
        <div class="cont_list flex">
            <p class="logo"><img src="@/assets/gd/logo.png"></p>
            <ul class="flex menu_list">
                <li :class="{'activeMenu': $route.name=='Index'}" @click="$router.push('/')">首页</li>
                <li :class="{'activeMenu': $route.name=='NewsList'}" @click="$router.push('/newsList')">新闻资讯</li>
                <li :class="{'activeMenu': $route.name=='TechnicalTeam'}" @click="$router.push('/technicalTeam')">技术服务队</li>
                <li :class="{'activeMenu': $route.name=='ServiceItems'}" @click="$router.push('/serviceItems')">服务项目</li>
                <li :class="{'activeMenu': $route.name=='StudyItems'}" @click="$router.push('/studyItems')">课程板块</li>
            </ul>
            <div class="right_btn_cont">

                <div class="userInfo flex" v-if="userInfo">
                    <p class="user_name">{{ userInfo.nickname }}</p>
                    <div class="logout-btn" @click="logout">退出登录</div>
                </div>
                <div class="btn_cont flex" v-else>
                    <p class="login-btn" @click="ShowLoginModal">登录</p>
                    <p class="reg-btn" @click="ShowComRegModal">企业注册</p>
                    <!-- <p class="btn2">注册</p> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
    name: "header_box",
    data() {
        return {
            userInfo: ''
        };
    },
    mounted() {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    },
    methods: {
        ...mapMutations(['ShowLoginModal', 'ShowComRegModal', 'ShowTipModal', 'ClearUserInfo']), //登录弹窗
        logout() {
            this.$confirm('确定退出账号?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.post(`/user/logout`, {}, { useLog: true }).then(res => {
                    if (res.code == 1) {
                        localStorage.clear();
                        sessionStorage.clear();
                        location.reload()
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            })
        }
    },
};
</script>
<style scoped lang="scss">
.header_box {
    height: 90px;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
    position: relative;
    z-index: 99;

    .cont_list {
        width: 1620px;
        height: 100%;
        margin: 0 auto;

        p.logo {
            min-width: 190px;
            height: 50px;

            img {
                width: auto;
                height: 100%;
            }
        }

        .menu_list {
            height: 100%;
            flex: 1;
            margin-left: 90px;
            justify-content: flex-end;

            li {
                margin-right: 60px;
                height: 100%;
                font-size: 24px;
                color: #333333;
                display: flex;
                align-items: center;
                position: relative;
                cursor: pointer;
            }

            .activeMenu {
                color: #0057B5;
                &::after{
                    content: '';
                    display: block;
                    width: 27px;
                    height: 4px;
                    background: #2256AE;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    margin:  0 auto;
                }
            }

            // .activeMenu::after{
            //     content: '';
            //     position: absolute;
            //     left: 50%;
            //     bottom: 10px;
            //     transform: translateX(-50%);
            //     width: 36px;
            //     height: 3px;
            //     background: #FF5F21;
            //     border-radius: 2px;
            // }
        }

        .right_btn_cont {
            height: 100%;
            display: flex;
            align-items: center;

            .btn_cont {
                p {
                    width: 104px;
                    height: 43px;
                    border-radius: 5px;
                    font-size: 18px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                }

                p.login-btn {
                    border: 1px solid #2255AE;
                    color: #2255AE;
                }
                p.reg-btn {
                    background-color: #2255AE;
                    color: #fff;
                    margin-left: 20px;
                }
            }

            .userInfo {
                height: 100%;
                position: relative;

                p.user_name {
                    font-size: 24px;
                    color: #2255AE;
                }

                .logout-btn {
                    width: 113px;
                    height: 43px;
                    background: #FFFFFF;
                    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
                    border-radius: 6px;
                    font-size: 17px;
                    color: #2255AE;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    left: 50%;
                    margin-left: -52px;
                    bottom: -34px;
                    display: none;
                    cursor: pointer;
                }

                &:hover {
                    .logout-btn {
                        display: flex;
                    }
                }
            }
        }
    }
}
</style>
